/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRightBar = createReactComponent("outline", "arrow-right-bar", "IconArrowRightBar", [["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M3 12h18", "key": "svg-1" }], ["path", { "d": "M3 9v6", "key": "svg-2" }]]);

export { IconArrowRightBar as default };
//# sourceMappingURL=IconArrowRightBar.mjs.map
